module.exports = __webpack_public_path__ + "static/media/close1.12be768a.svg";